import Livestream from '@/views/settings/Livestream'
import TvApp from '@/views/settings/TvApp.vue'

export default [
  {
    path: ':clientId/livestream',
    name: 'livestream.index',
    component: Livestream,
    meta: { featureKey: 'livestream' }
  },
  {
    path: ':clientId/tv-app',
    name: 'tvApp.index',
    component: TvApp,
    meta: { featureKey: 'tv-app' }
  }
]
